export default function StarMosaic() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2413_1809)">
                <rect width="100%" height="100%" fill="#01B4EE" />
                <path d="M430.344 108.968C462.378 58.029 536.622 58.029 568.656 108.968L682.824 290.51C689.347 300.882 698.118 309.653 708.49 316.176L890.032 430.344C940.971 462.378 940.971 536.622 890.032 568.656L708.49 682.824C698.118 689.347 689.347 698.118 682.824 708.49L568.656 890.032C536.622 940.971 462.378 940.971 430.344 890.032L316.176 708.49C309.653 698.118 300.882 689.347 290.51 682.824L108.968 568.656C58.029 536.622 58.029 462.378 108.968 430.344L290.51 316.176C300.882 309.653 309.653 300.882 316.176 290.51L430.344 108.968Z" fill="#FFC525" />
            </g>
            <defs>
                <clipPath id="clip0_2413_1809">
                    <rect width="100%" height="100%" fill="white" />
                </clipPath>
            </defs>
        </svg>


    )
}